document.addEventListener('alpine:init', () => {
  Alpine.data('Clock', () => ({
    time: new Date().toLocaleTimeString(window.Shopify.locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }),
    date: new Date().toLocaleDateString(window.Shopify.locale, {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }),
    init() {
      this.updateTime();
      this.updateDate();
      setInterval(() => this.updateTime(), 1000);
    },
    updateTime() {
      this.time = new Date().toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    updateDate() {
      this.date = new Date().toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
      });
    },
  }));
});
